import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import BlogListing from '../components/BlogListing';
import NewsletterSignup from '../components/NewsletterSignup';
import SubBanner from '../components/SubBanner';

const BlogAuthorDetailPageTemplate = ({
  data: {
    datoCmsBlogAuthor,
    allDatoCmsBlog: { nodes },
  },
}) => {
  const { seoMetaTags, title, biography, image } = datoCmsBlogAuthor;

  return (
    <Layout seo={seoMetaTags} noIndex={true} page={datoCmsBlogAuthor}>
      <main>
        <SubBanner
          heading={title}
          text={`<p>${biography}</p>`}
          image={image}
          isAuthor={true}
        />
        <BlogListing
          heading={`Showing all posts from ${title}`}
          items={nodes}
        />
        <NewsletterSignup />
      </main>
    </Layout>
  );
};

export const BlogAuthorDetailPageTemplateQuery = graphql`
  query BlogAuthorDetailPageTemplateQuery($id: String!) {
    datoCmsBlogAuthor(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      slug
      biography
      image {
        gatsbyImageData(width: 320, height: 320)
        alt
      }
      ...LinkFragment
    }
    allDatoCmsBlog(
      filter: { author: { id: { eq: $id } } }
      sort: { meta: { firstPublishedAt: DESC } }
    ) {
      nodes {
        ...BlogCardFragment
      }
    }
  }
`;

export default BlogAuthorDetailPageTemplate;
